module.exports = __webpack_public_path__ + "static/img/news-demo4.1489393.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/news/news-demo4.png
// module id = jU+i
// module chunks = 31